<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BuxLTg/tc-custom/9781429986335.jpg?1733087319211" alt="This image is the cover for the book Godchildren"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Godchildren
      </h1>
      <p class="bookDescription body article font2">
        <p><i>All the godchildren, looking back on that fateful dinner, remembered it in the same way:  the vacant wooden throne at the head of the table, the huge array of wine glasses and water glasses that were always a feature of dining at any of Marcus' houses, the sense of expectation and dread that hung over them like a cloud of mustard gas.<br/><br/></i>In his magnificent island home overlooking the sea, the great tycoon Marcus Brand plays host to his six godchildren. But soon, secrets will be revealed that dramatically alter the tone of this holiday weekend, and all will have to confront a web of betrayals and lies spanning four decades…<br/><br/>Each from a different background, the godchildren grew up enthralled by their godfather: Charlie, fascinated by Marcus's wealth; Mary, whose life is blighted by tragedy; Jamie, feckless but utterly charming; Saffron, stunningly beautiful but unaware of her power over men; Abigail, insecure and gauche; and Stuart, who is torn between admiration and hatred for his capitalist godfather. <br/><br/><i>Godchildren</i> is an epic tale; powerful, engrossing, and impossible to put down. With his trademark blend of wicked satire and impeccable writing, Coleridge has created gloriously jaw dropping portrait of the British upper crust.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholas Coleridge
      </h2>
      
      <p class="authorDescription body article"><B>Nicholas Coleridge</B> is managing director of Condé Nast in Britain, the magazine publishing house that includes Vogue, Tatler, House & Garden and Vanity Fair. His bestselling novels have been published in twelve languages.  He lives in England with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ccb4a0b2